import { __rest, __assign, __spreadArray } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { useState, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { AccordionBody } from './AccordionBody.js';
import { AccordionHeader } from './AccordionHeader.js';
import { AccordionItem } from './AccordionItem.js';
import { AccordionContext } from './context.js';

var Accordion = function (_a) {
    var children = _a.children, className = _a.className, defaultOpen = _a.defaultOpen, _b = _a.flush, flush = _b === void 0 ? false : _b, _c = _a.hasIconPrefix, hasIconPrefix = _c === void 0 ? false : _c, _d = _a.marketing, marketing = _d === void 0 ? false : _d, open = _a.open, onToggleOpen = _a.onToggleOpen, _e = _a.square, square = _e === void 0 ? false : _e, _f = _a.size, size = _f === void 0 ? 'md' : _f, _g = _a.stayOpen, stayOpen = _g === void 0 ? false : _g, _h = _a.tag, Tag = _h === void 0 ? 'div' : _h, attributes = __rest(_a, ["children", "className", "defaultOpen", "flush", "hasIconPrefix", "marketing", "open", "onToggleOpen", "square", "size", "stayOpen", "tag"]);
    var _j = useState(Array.isArray(defaultOpen) ? defaultOpen : defaultOpen ? [defaultOpen] : []), openIds = _j[0], setOpenIds = _j[1];
    useEffect(function () {
        setOpenIds(Array.isArray(defaultOpen) ? defaultOpen : defaultOpen ? [defaultOpen] : []);
    }, [defaultOpen]);
    var uncontrolledOnToggleOpen = function (id) {
        if (openIds.includes(id)) {
            return setOpenIds(function (prevState) { return prevState.filter(function (prevId) { return prevId !== id; }); });
        }
        if (stayOpen) {
            setOpenIds(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [id], false); });
        }
        else {
            setOpenIds([id]);
        }
    };
    var realOpenIds = useMemo(function () {
        return open !== undefined ? (Array.isArray(open) ? open : [open]) : openIds;
    }, [open, openIds]);
    return (jsx(AccordionContext.Provider, __assign({ value: { onToggleOpen: onToggleOpen || uncontrolledOnToggleOpen, openIds: realOpenIds } }, { children: jsx(Tag, __assign({}, attributes, { className: classNames('accordion', flush && 'accordion-flush', marketing && 'accordion-marketing', square && "rounded-0", size !== 'md' && "accordion-".concat(size), hasIconPrefix && 'accordion-has-btn-icon-prefix', className), "data-testid": "accordion" }, { children: children })) })));
};
Accordion.Body = AccordionBody;
Accordion.Header = AccordionHeader;
Accordion.Item = AccordionItem;

export { Accordion };
